import {
  initialState,
  Actions,
  State,
  GET_ONE_INSPECTION,
  GET_ONE_INSPECTION_SUCCESS,
  GET_ONE_INSPECTION_ERROR,
  RESET_GET_ONE_INSPECTION,
} from '../../types/inspection/get-one'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_ONE_INSPECTION:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case GET_ONE_INSPECTION_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case GET_ONE_INSPECTION_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_GET_ONE_INSPECTION:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducers
